import { Omit } from "lodash";
import { ReactNode } from "react";
import tw from "twin.macro";

import { Input, InputProps } from "../atoms/Input";

const Accessory = tw.div`inline-block rounded pt-1 pb-[3px] px-1.5 ml-1.5 font-base font-bold text-2xs text-white tracking-[-.3px] leading-none mb-0.5`;

export interface InputWithLabelProps extends Omit<InputProps, "name"> {
  name?: string;
  label?: string;
  renderLabel?: ReactNode;
  renderInput?: ReactNode;
  hint?: string;
  required?: boolean;
  optional?: boolean;
  displayError?: boolean;
}

/**
 * @param name [string]
 * @param label [string]
 * @param renderInput [JSX.Element]
 * @param hint [string]
 * @param required [boolean]
 * @param optional [boolean]
 * @param displayError [boolean]
 */
export const InputWithLabel = ({
  name,
  label,
  renderLabel,
  renderInput,
  hint,
  required,
  optional,
  className,
  ...rest
}: InputWithLabelProps) => {
  return (
    <div tw="flex flex-col w-full mb-4" className={className}>
      {!renderLabel && label && (
        <div tw="flex items-center">
          <h4 tw="font-base text-sm leading-[14px]">{label}</h4>
          {required && <Accessory tw="bg-gradient-theme-to-l">必須</Accessory>}
          {optional && <Accessory tw="bg-secondary">任意</Accessory>}
        </div>
      )}
      {renderLabel && renderLabel}
      <div tw="mt-[11px] flex flex-col items-center">
        {renderInput ? renderInput : <Input name={name} {...rest} />}
      </div>
      {hint && <span tw="font-light text-[8px] text-black mt-2">{hint}</span>}
    </div>
  );
};

InputWithLabel.displayName = "InputWithLabel";
